import { apiWithBody, apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_Environment, DBDef_Environment } from '@app/org-shared';
export const dispatch_onEnvironmentChanged = new ThunderDispatcherV3('__onEnvironmentUpdated');
export class ModuleFE_Environment_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_Environment, dispatch_onEnvironmentChanged);
        this._v1 = {
            getCertData: apiWithBody(ApiDef_Environment._v1.getCertData),
            getQuaiEnvironments: apiWithQuery(ApiDef_Environment._v1.getQuaiEnvironments),
            getEnvironment: apiWithQuery(ApiDef_Environment._v1.getEnvironment),
            buildOrganizationData: apiWithQuery(ApiDef_Environment._v1.buildOrganizationData),
            getJwksEpicPrd: apiWithQuery(ApiDef_Environment._v1.getJwksEpicPrd),
            getJwksEpicNonprd: apiWithQuery(ApiDef_Environment._v1.getJwksEpicNonprd),
            getJwksFhirEpic: apiWithQuery(ApiDef_Environment._v1.getJwksFhirEpic),
        };
    }
}
export const ModuleFE_Environment = new ModuleFE_Environment_Class();
//# sourceMappingURL=ModuleFE_Environment.js.map